import './About.css';

import { useTranslation } from 'react-i18next';

function About() {

  const { t } = useTranslation();

  return (

    <section className="about" id="about">

      <div className="about-container">

        <div className="about-image">

          <div className="about-placeholder">

            {t('about.imagePlaceholder')}

          </div>

        </div>


        <div className="about-content">

          <p className="section-label">

            {t('about.label')}

          </p>


          <h2>

            {t('about.title')}

          </h2>


          <p>

            {t('about.paragraph1')}

          </p>


          <p>

            {t('about.paragraph2')}

          </p>

        </div>

      </div>

    </section>

  );

}

export default About;

